import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TokenContextType {
  token: string;
  setToken: (token: string) => void;
}

const TokenContext = createContext<TokenContextType | undefined>(undefined);

export const useToken = () => {
  const context = useContext(TokenContext);
  if (!context) throw new Error('useToken must be used within TokenProvider');
  return context;
};

export const TokenProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState<string>('');
  return (
    <TokenContext.Provider value={{ token, setToken }}>
      {children}
    </TokenContext.Provider>
  );
};